import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios'

export const VIDEO_SERVER_URL = "http://192.168.1.143:8000/api/v1"

// Create axios instance
export const api: AxiosInstance = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add CSRF token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Get CSRF token from localStorage or session
    const csrfToken = localStorage.getItem('csrf_token')
    if (csrfToken && (config.method === 'post' || config.method === 'put' || config.method === 'delete' || config.method === 'patch')) {
      config.headers = {
        ...config.headers,
        'X-CSRF-Token': csrfToken,
      } as any
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect for auth endpoints (they handle 401 themselves)
      const url = error.config?.url || ''
      const isAuthEndpoint = url.includes('/auth/me') || 
                            url.includes('/auth/login') || 
                            url.includes('/auth/logout') ||
                            url.includes('/auth/csrf-token') ||
                            url.includes('/auth/reset-password')
      
      // Only redirect if not already on login page and not an auth endpoint
      if (!isAuthEndpoint && !window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// Update CSRF token in localStorage
export const updateCsrfToken = (token: string) => {
  localStorage.setItem('csrf_token', token)
}

// Remove CSRF token from localStorage
export const removeCsrfToken = () => {
  localStorage.removeItem('csrf_token')
}
